<template>
  <b-modal
    id="modal-agente-saude"
    ref="modalAgenteSaude"
    title="Agente de saúde"
    centered
    hide-footer
    @hidden="onHidden"
  >
    <b-alert
      v-if="modalAlert.show"
      :variant="modalAlert.variant"
      show
      class="mb-3"
    >
      {{ modalAlert.message }}
    </b-alert>

    <div v-if="modalLoading" class="modal-loading">
      <div class="text-center">
        <b-spinner label="Carregando" />
      </div>
    </div>

    <div v-else class="modal-agente-saude">
      <div class="bloco-resumo">
        <div class="row">
          <div class="col-md-4">
            <div class="info-item">
              <span class="info-label">UBS</span>
              <strong class="info-value">
                {{ microArea?.no_unidade_saude || '-' }}
              </strong>
            </div>
          </div>

          <div class="col-md-4">
            <div class="info-item">
              <span class="info-label">Equipe</span>
              <strong class="info-value">
                {{ microArea?.no_equipe || '-' }}
              </strong>
            </div>
          </div>

          <div class="col-md-4">
            <div class="info-item">
              <span class="info-label">Microárea</span>
              <strong class="info-value">
                {{ microArea?.nu_micro_area || '-' }}
              </strong>
            </div>
          </div>
        </div>
      </div>

      <b-tabs
        content-class="pt-3"
        class="tabs-agente-saude esus-feedback-tabs tabs-auto"
      >
        <b-tab title="Vínculo atual" active>
          <div class="bloco-secao mb-0">
            <div v-if="agenteAtivo" class="card-agente card-agente--ativo">
              <div
                class="d-flex justify-content-between align-items-start mb-2"
              >
                <div>
                  <div class="nome-agente">
                    {{ agenteAtivo.no_profissional }}
                  </div>
                  <div class="detalhe-agente">
                    CPF: {{ agenteAtivo.cpf_profissional || '-' }}
                  </div>
                </div>

                <span class="badge-status badge-status--ativo">Vigente</span>
              </div>

              <div class="periodo-agente">
                <div class="d-flex align-items-center flex-wrap gap-2">
                  <span>Início:</span>

                  <template v-if="editando">
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      style="width: 150px"
                      v-model="formEdicao.data_inicio"
                    />
                  </template>
                  <template v-else>
                    <strong>{{ formatarData(agenteAtivo.data_inicio) }}</strong>
                  </template>

                  <span class="mx-2">|</span>

                  <span>Fim:</span>

                  <template v-if="editando">
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      style="width: 150px"
                      v-model="formEdicao.data_fim"
                    />
                  </template>
                  <template v-else>
                    <strong>{{ formatarData(agenteAtivo.data_fim) }}</strong>
                  </template>
                </div>

                <div v-if="editando" class="form-group mt-3 mb-0">
                  <label>Observações</label>
                  <textarea
                    class="form-control form-control-sm"
                    v-model="formEdicao.observacoes"
                    rows="3"
                    placeholder=""
                  ></textarea>
                </div>

                <div class="acoes-agente-ativo mt-3">
                  <b-button
                    size="sm"
                    class="btn-acao btn-salvar-inline"
                    :disabled="saving"
                    @click="editando ? salvarEdicao() : iniciarEdicao()"
                  >
                    <b-spinner small class="mr-1" v-if="saving"></b-spinner>

                    <i
                      class="icofont-edit mr-1"
                      v-if="!editando && !saving"
                    ></i>
                    <i
                      class="icofont-check mr-1"
                      v-if="editando && !saving"
                    ></i>

                    {{ editando ? 'Salvar' : 'Editar' }}
                  </b-button>
                </div>
              </div>
            </div>

            <div v-else class="empty-agente">
              Nenhum Agente de Saúde vinculado a esta microárea.
            </div>
          </div>

          <div
            v-if="!mostrarFormSubstituicao && !mostrarFormEncerramento"
            class="bloco-acoes"
          >
            <b-button
              v-if="!agenteAtivo"
              class="btn-acao btn-vincular"
              :disabled="saving"
              @click="abrirFormSubstituicao"
            >
              <i class="icofont-plus mr-1"></i>
              Vincular agente de saúde
            </b-button>

            <template v-else>
              <b-button
                class="btn-acao btn-substituir"
                :disabled="saving"
                @click="abrirFormSubstituicao"
              >
                <i class="icofont-refresh mr-1"></i>
                Substituir agente
              </b-button>
            </template>
          </div>

          <div
            v-if="mostrarFormSubstituicao"
            class="bloco-form bloco-form--substituicao"
          >
            <div class="bloco-form-header">
              <h6 class="bloco-form-titulo">Novo vínculo</h6>
              <button class="btn-link-cancelar" @click="cancelarFormularios">
                Cancelar
              </button>
            </div>

            <div class="form-group">
              <label>Agente de saúde</label>
              <vue-select
                :options="profissionaisOptions"
                label="no_profissional"
                placeholder="Selecione o agente..."
                v-model="formSubstituicao.profissional"
                :clearable="false"
                @input="onSelecionarProfissional"
              >
                <template slot="option" slot-scope="option">
                  {{ option.nu_cpf }} - {{ option.no_profissional }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>

            <div class="form-group">
              <label>Data de início na microárea</label>
              <input
                type="date"
                class="form-control"
                v-model="formSubstituicao.data_inicio"
              />
            </div>

            <div class="form-group">
              <label>Observações</label>
              <textarea
                class="form-control"
                v-model="formSubstituicao.observacoes"
                rows="3"
                placeholder=""
              ></textarea>
            </div>

            <p class="texto-auxiliar">
              O vínculo atual será encerrado automaticamente com data final
              igual à data inicial do novo vínculo.
            </p>
          </div>
        </b-tab>

        <b-tab>
          <template #title>
            Histórico
            <span class="badge-tab">{{ historico.length }}</span>
          </template>

          <div class="bloco-secao mb-0">
            <div v-if="historico.length">
              <div
                v-for="(item, index) in historico"
                :key="index"
                class="card-agente card-agente--historico"
              >
                <div
                  class="d-flex justify-content-between align-items-start mb-2"
                >
                  <div>
                    <div class="nome-agente">{{ item.no_profissional }}</div>
                  </div>

                  <span
                    class="badge-status"
                    :class="
                      item.ativo
                        ? 'badge-status--ativo'
                        : 'badge-status--encerrado'
                    "
                  >
                    {{ item.ativo ? 'Ativo' : 'Encerrado' }}
                  </span>
                </div>

                <div class="detalhe-agente">
                  CPF: {{ item.cpf_profissional || '-' }}
                </div>
                <div class="periodo-agente">
                  Início:
                  <strong>{{ formatarData(item.data_inicio) }}</strong>
                  <span class="mx-2">|</span>
                  Fim:
                  <strong>{{ formatarData(item.data_fim) }}</strong>
                </div>
                <div v-if="item.anotacoes" class="anotacoes-agente">
                  <span>Observações:</span>
                  <span>{{ item.anotacoes }}</span>
                </div>
              </div>
            </div>

            <div v-else class="empty-state">Nenhum histórico encontrado.</div>
          </div>
        </b-tab>
      </b-tabs>

      <div
        v-if="mostrarFormSubstituicao || mostrarFormEncerramento"
        class="modal-footer-acoes"
      >
        <b-button
          class="btn-footer-cancelar"
          :disabled="saving"
          @click="cancelarFormularios"
        >
          Cancelar
        </b-button>

        <b-button
          v-if="mostrarFormSubstituicao"
          class="btn-footer-salvar"
          :disabled="saving"
          @click="confirmarSubstituicao"
        >
          Salvar
        </b-button>

        <b-button
          v-if="mostrarFormEncerramento"
          class="btn-footer-encerrar"
          :disabled="saving"
          @click="confirmarEncerramento"
        >
          Encerrar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import utils from '@/mixins/utils'

export default {
  name: 'ModalAgenteSaude',
  mixins: [utils],
  props: {
    modalLoading: {
      type: Boolean,
      default: false,
    },
    microArea: {
      type: Object,
      default: () => null,
    },
    agenteAtivo: {
      type: Object,
      default: () => null,
    },
    historico: {
      type: Array,
      default: () => [],
    },
    profissionaisOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      saving: false,
      modalAlert: {
        show: false,
        variant: 'success',
        message: '',
      },
      mostrarFormSubstituicao: false,
      mostrarFormEncerramento: false,
      formSubstituicao: {
        profissional: null,
        data_inicio: '',
        observacoes: '',
      },
      formEncerramento: {
        data_fim: '',
        observacoes: '',
      },
      editando: false,
      formEdicao: {
        data_inicio: '',
        data_fim: '',
        observacoes: '',
      },
    }
  },
  methods: {
    /** Abre o modal */
    abrir() {
      this.$refs.modalAgenteSaude.show()
    },

    /** Fecha o modal */
    fechar() {
      this.$refs.modalAgenteSaude.hide()
    },

    /** Evento ao fechar o modal */
    onHidden() {
      this.resetEstadoLocal()
      this.$emit('hidden')
    },

    /** Reseta o estado interno do modal */
    resetEstadoLocal() {
      this.saving = false
      this.modalAlert = {
        show: false,
        variant: 'success',
        message: '',
      }
      this.cancelarFormularios()
      this.editando = false
      this.formEdicao = {
        data_inicio: '',
        data_fim: '',
        observacoes: '',
      }
    },

    /** Cancela e limpa os formulários */
    cancelarFormularios() {
      this.mostrarFormSubstituicao = false
      this.mostrarFormEncerramento = false
      this.formSubstituicao = {
        profissional: null,
        data_inicio: '',
        observacoes: '',
      }
      this.formEncerramento = {
        data_fim: '',
        observacoes: '',
      }
    },

    /** Abre o formulário de substituição */
    abrirFormSubstituicao() {
      this.editandoInicio = false
      this.editandoFim = false
      this.mostrarFormEncerramento = false
      this.mostrarFormSubstituicao = true
    },

    /** Abre o formulário de encerramento */
    abrirFormEncerramento() {
      this.mostrarFormSubstituicao = false
      this.mostrarFormEncerramento = true
    },

    /** Exibe mensagem de sucesso */
    exibirSucesso(message) {
      this.modalAlert = {
        show: true,
        variant: 'success',
        message,
      }
    },

    /** Exibe mensagem de erro */
    exibirErro(message) {
      this.modalAlert = {
        show: true,
        variant: 'danger',
        message,
      }
    },

    /** Formata data para exibição */
    formatarData(data) {
      if (!data) {
        return '-'
      }

      return this.formatDate ? this.formatDate(data) : data
    },

    /** Confirma substituição de agente */
    confirmarSubstituicao() {
      if (
        !this.formSubstituicao.profissional ||
        !this.formSubstituicao.data_inicio
      ) {
        this.exibirErro('Selecione o agente e informe a data inicial.')
        return
      }

      this.saving = true
      this.modalAlert.show = false

      this.$emit('substituir', {
        microArea: this.microArea,
        agenteAtual: this.agenteAtivo,
        novoAgente: this.formSubstituicao.profissional,
        data_inicio: this.formSubstituicao.data_inicio,
        anotacoes: this.formSubstituicao.observacoes,
        onSuccess: (message) => {
          this.exibirSucesso(message)
          this.saving = false
          this.cancelarFormularios()
        },
        onError: (message) => {
          this.exibirErro(message)
          this.saving = false
        },
      })
    },

    /** Confirma encerramento de vínculo */
    confirmarEncerramento() {
      if (!this.formEncerramento.data_fim) {
        this.exibirErro('Informe a data final do vínculo.')
        return
      }

      this.saving = true
      this.modalAlert.show = false

      this.$emit('encerrar-vinculo', {
        microArea: this.microArea,
        agenteAtivo: this.agenteAtivo,
        data_fim: this.formEncerramento.data_fim,
        anotacoes: this.formEncerramento.observacoes,
        onSuccess: (message) => {
          this.exibirSucesso(message)
          this.saving = false
          this.cancelarFormularios()
        },
        onError: (message) => {
          this.exibirErro(message)
          this.saving = false
        },
      })
    },

    /**
     * Abre o modal de edição
     */
    iniciarEdicao() {
      this.modalAlert.show = false
      this.editando = true
      this.formEdicao = {
        data_inicio: this.agenteAtivo?.data_inicio || '',
        data_fim: this.agenteAtivo?.data_fim || '',
        observacoes: this.agenteAtivo?.anotacoes || '',
      }
    },

    /**
     * Salva a edição
     */
    salvarEdicao() {
      if (!this.formEdicao.data_inicio) {
        this.exibirErro('Informe a data inicial.')
        return
      }

      this.saving = true
      this.modalAlert.show = false

      if (this.formEdicao.data_fim) {
        this.$emit('encerrar-vinculo', {
          microArea: this.microArea,
          agenteAtivo: this.agenteAtivo,
          data_fim: this.formEdicao.data_fim,
          anotacoes: this.formEdicao.observacoes,
          onSuccess: (msg) => {
            this.exibirSucesso(msg)
            this.editando = false
            this.saving = false
          },
          onError: (msg) => {
            this.exibirErro(msg)
            this.saving = false
          },
        })
        return
      }

      this.$emit('atualizar-vinculo', {
        microArea: this.microArea,
        agenteAtivo: this.agenteAtivo,
        data_inicio: this.formEdicao.data_inicio,
        anotacoes: this.formEdicao.observacoes,
        onSuccess: (msg) => {
          this.exibirSucesso(msg)
          this.editando = false
          this.saving = false
        },
        onError: (msg) => {
          this.exibirErro(msg)
          this.saving = false
        },
      })
    },

    /**
     * Busca a menor data de visita conforme INE e microárea.
     *
     * @param {Object|null} profissional
     * @returns {string}
     */
    getDtMinVisita(profissional) {
      try {
        if (!profissional) return ''

        let dados = JSON.parse(profissional.dados || '[]')

        let item = dados.find((registro) => {
          return (
            registro.ine === profissional?.nu_ine &&
            String(registro.micro_area) ===
              String(this.microArea?.nu_micro_area)
          )
        })

        return item?.dt_min_visita || ''
      } catch (error) {
        return ''
      }
    },

    /**
     * Ao selecionar um agente de saúde, preenche a data inicial
     * com a dt_min_visita, se existir.
     *
     * @param {Object|null} profissional
     */
    onSelecionarProfissional(profissional) {
      this.formSubstituicao.data_inicio = this.getDtMinVisita(profissional)
    },
  },
}
</script>

<style lang="scss">
#modal-agente-saude {
  .modal-dialog {
    max-width: 650px;
  }

  .modal-agente-saude {
    .bloco-resumo,
    .bloco-secao,
    .bloco-form {
      margin-bottom: 20px;
    }

    .bloco-resumo {
      padding: 16px;
      border: 1px solid #e9ecef;
      border-radius: 10px;
      background: #f8f9fa;
    }

    .info-item {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .info-label {
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      color: #6c757d;
    }

    .info-value {
      font-size: 15px;
      color: #212529;
    }

    .secao-titulo {
      margin-bottom: 12px;
      font-weight: 700;
      color: #495057;
    }

    .card-agente {
      border-radius: 10px;
      padding: 14px 16px;
      margin-bottom: 12px;
      border: 1px solid #dee2e6;
      background: #fff;
    }

    .card-agente--ativo {
      border-color: #b7ebc6;
      background: #f3fbf5;
    }

    .card-agente--historico {
      background: #fafafa;
    }

    .nome-agente {
      font-size: 16px;
      font-weight: 700;
      color: #212529;
    }

    .detalhe-agente,
    .periodo-agente {
      font-size: 13px;
      color: #6c757d;
    }

    .anotacoes-agente {
      font-size: 13px;
      color: #6c757d;
      line-height: 1.4;
      span:first-child {
        margin-right: 4px;
      }
    }

    .empty-agente {
      background: rgb(254, 242, 242);
      border-radius: 10px;
      padding: 14px;
      margin-bottom: 16px;
      border: 1px solid rgb(254, 202, 202);
      font-size: 13px;
      color: rgb(220, 38, 38);
      font-weight: 600;
    }

    .badge-status {
      font-size: 11px;
      font-weight: 700;
      border-radius: 999px;
      padding: 4px 10px;
      text-transform: uppercase;
    }

    .badge-status--ativo {
      background: #d1f2db;
      color: #198754;
    }

    .badge-status--encerrado {
      background: #f8d7da;
      color: #842029;
    }

    .bloco-acoes {
      display: flex;
      gap: 10px;
      margin-bottom: 24px;
    }

    .btn-acao {
      flex: 1;
      height: 42px;
      border-radius: 10px;
      font-weight: 600;
    }

    .btn-vincular {
      background: #f1f3f5;
      color: #495057;
      border: 1px dashed #ced4da;

      &:hover {
        background: #e9ecef;
        color: #212529;
      }
    }

    .btn-substituir {
      background: #f8f9fa;
      color: #4a5568;
      border: 1px dashed #bfc8d4;

      &:hover {
        background: #eef2f7;
        color: #364152;
      }
    }

    .btn-encerrar-vinculo {
      background-color: #fdecea;
      color: #dc3545;
      border: 1px dashed #f3b2b8;

      &:hover {
        background-color: #f8d7da;
        color: #b02a37;
      }

      &:active {
        background-color: #f1b0b7;
      }

      &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
      }
    }

    .bloco-form {
      border-radius: 10px;
      padding: 16px;
      border: 1px solid #d7dee8;
      background: #f8fbff;
    }

    .bloco-form--encerramento {
      border-color: #f3c2c7;
      background: #fff8f8;
    }

    .bloco-form-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .bloco-form-titulo {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      text-transform: uppercase;
      color: #315efb;
    }

    .bloco-form--encerramento .bloco-form-titulo {
      color: #dc3545;
    }

    .btn-link-cancelar {
      border: none;
      background: transparent;
      font-size: 13px;
      color: #6c757d;
      text-decoration: underline;
      cursor: pointer;
      padding: 0;
    }

    .texto-auxiliar {
      margin-top: 12px;
      margin-bottom: 0;
      font-size: 13px;
      color: #6c757d;
      line-height: 1.5;
    }

    .texto-auxiliar--encerramento {
      margin-top: 0;
      margin-bottom: 16px;
      color: #5c677d;
    }

    .empty-state {
      padding: 14px 16px;
      border: 1px dashed #ced4da;
      border-radius: 10px;
      color: #6c757d;
      background: #fcfcfc;
      font-size: 14px;
    }

    .acoes-agente-ativo {
      display: flex;
      align-items: center;
      gap: 10px;
      .btn-salvar-inline {
        background-color: #198754;
        color: #fff;
        border: 1px dashed #a3d9b1;

        &:hover {
          background-color: #d1f2db;
          color: #146c43;
        }

        &:active {
          background-color: #b7ebc6;
        }

        &:disabled {
          opacity: 0.65;
          cursor: not-allowed;
        }
      }
    }

    .tabs-agente-saude {
      .nav-tabs {
        border-bottom: 1px solid #e5e7eb;
        margin-bottom: 0;
      }

      .nav-link {
        border: none;
        border-bottom: 2px solid transparent;
        border-radius: 0;
        background: transparent;
        font-weight: 600;
        padding: 10px 14px;
        text-transform: initial !important;
        font-size: 20px;
      }

      .badge-tab {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 18px;
        height: 18px;
        padding: 0 6px;
        margin-left: 6px;
        border-radius: 999px;
        background: #e5e7eb;
        color: #4b5563;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
      }
    }
  }

  .modal-footer-acoes {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 18px;
    margin-top: 12px;
    border-top: 1px solid #e5e7eb;
  }

  .btn-footer-cancelar {
    min-width: 96px;
    height: 42px;
    border-radius: 12px;
    background: #fff;
    color: #64748b;
    border: 1px solid #d1d5db;
    font-weight: 600;

    &:hover {
      background: #f8fafc;
      color: #475569;
    }
  }

  .btn-footer-salvar {
    min-width: 96px;
    height: 42px;
    border-radius: 12px;
    background: #0fafd7;
    color: #fff;
    border: 1px solid #0fafd7;
    font-weight: 700;

    &:hover {
      background: #0fafd7;
      border-color: #0fafd7;
      color: #fff;
    }
  }

  .btn-footer-encerrar {
    min-width: 96px;
    height: 42px;
    border-radius: 12px;
    background: #dc2626;
    color: #fff;
    border: 1px solid #dc2626;
    font-weight: 700;

    &:hover {
      background: #b91c1c;
      border-color: #b91c1c;
      color: #fff;
    }
  }
}
</style>
